import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { DateFormatter, DateFormatType } from '../../../utils/dateFormatter';
import { ExamReportResponse, ExamReportsClient } from '../../../generated-client/generated-api-client';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SyncDataService } from '../../../services/data-services/sync-data.service';
import { ErrorProcessorService } from '../../../services/error-processor.service';

@Component({
  selector: 'app-exam-report-edit',
  templateUrl: './exam-report-edit.component.html',
  styleUrls: ['./exam-report-edit.component.sass'],
})
export class ExamReportEditComponent implements OnInit {
  id: string = '';
  response!: Observable<ExamReportResponse>;
  activeTab!: string;
  syncInfo?: string;
  canSync?: boolean;

  constructor(
    private titleService: Title,
    private route: ActivatedRoute,
    private client: ExamReportsClient,
    private _examReportsClient: ExamReportsClient,
    private toastr: ToastrService,
    private _syncService: SyncDataService,
    private errorProcessorService: ErrorProcessorService
  ) {
    route.paramMap.subscribe(next => {
      this.id = next.get('id') ?? '';
    });
  }

  afterSuccessfulOperationSubscription!: Subscription;

  changeTab(activeTab: string) {
    if (this.activeTab !== activeTab) {
      this.activeTab = activeTab;
    }
  }

  ngOnInit(): void {
    this.getSyncInfo();
    const activeTab = this.route.children[0].snapshot.url[0].path;
    this.changeTab(activeTab);
    this.afterSuccessfulOperationSubscription = this._syncService
      .getAfterSuccessfulOperation()
      .subscribe(() => this.getSyncInfo());
  }

  /*
   * @returns {Promise<boolean>} - Returns whether the page needs to be reloaded or not
   */
  public getSyncInfo(): Promise<boolean> {
    const previousCanSync = this.canSync;
    return new Promise<boolean>(resolve => {
      this._examReportsClient.syncGet(this.id).subscribe(
        response => {
          if (response.lastSyncDate) {
            const lastSyncDate = DateFormatter.format(response.lastSyncDate.toString(), DateFormatType.DateTime);
            this.syncInfo = `Utolsó szinkronizálás időpontja: ${lastSyncDate}`;
          }

          this.canSync = response.canSync;

          this._examReportsClient.isModifiable(this.id).subscribe(isModifiable => {
            this.canSync = response.canSync && isModifiable;
            resolve((previousCanSync && !this.canSync && !isModifiable) as boolean);
          });
        },
        error => this.errorProcessorService.processError(error, true)
      );
    });
  }

  public sync(): void {
    this.toastr.info('Szinkronizáció megkezdve');
    this._examReportsClient.syncPost(this.id).subscribe(
      () => {
        this.toastr.success('Sikeres szinkronizáció');
        this.getSyncInfo().then(reload => {
          if (reload) {
            window.location.reload();
          }
        });
      },
      error => this.errorProcessorService.processError(error, true, false, { 400: 'Sikertelen szinkronizáció!' })
    );
  }
}
